import React, { Component } from 'react';
import moment from "moment";
import {DateRangepicker} from '../uielements/datePicker';
import { Icon } from 'antd';

const RangePicker = DateRangepicker;
const dateFormat = "DD/MM/YYYY";

export default class extends Component {
  constructor(props){
    super(props);
    const format = this.props.dateFormat || dateFormat
    this.state = {
      /*value: this.props.value === '' ? moment() : moment(this.props.value, this.props.dateFormat || dateFormat),*/
      valueStr: this.props.value === '' ? `${moment().format(format)} - ${moment().format(format)}` : this.props.value,
      editable: true
    };
  }

  handleChange = moment => {

  };
  check = () => {
    this.setState({ editable: false });
    if (this.props.onChange) {
      this.props.onChange(
        this.state.valueStr,
        this.props.columnsKey,
        this.props.index
      );
    }
  };
  edit = () => {
    this.setState({ editable: true });
  };
  render() {
    const { valueStr, editable } = this.state;
    const format = this.props.dateFormat || dateFormat
    let start = undefined;
    let end = undefined;
    const index = valueStr.indexOf(' - ');
    if(index != -1){
      start = moment(valueStr.substring(0, index), format);
      end = moment(valueStr.substring(index+3), format);
    }else{
      start = moment(valueStr, format);
      end = moment(valueStr, format);
    }
    return (
      <div className="isoEditData">
        <div className="isoEditDataWrapper">
          <RangePicker
            ranges={{
              Today: [moment(), moment()],
              'This Month': [moment(), moment().endOf('month')]
            }}
            showTime
            style={{width: '95%'}}
            allowClear={false}
            format={this.props.dateFormat || dateFormat}
            value={[start, end]}
            onChange={(value) => {
              try {
                const start = value[0].toDate();
                const end = value[1].toDate();

                const startStr = moment(start).format(this.props.dateFormat || dateFormat)
                const endStr = moment(end).format(this.props.dateFormat || dateFormat)

                this.setState({ valueStr:`${startStr} - ${endStr}` });
                if (this.props.onChange) {
                  this.props.onChange(
                    `${startStr} - ${endStr}`,
                    this.props.columnsKey,
                    this.props.index
                  );
                }
              } catch (e) {}
            }}
          />
        </div>
      </div>
    );
  }
}
